import React, { useEffect, useMemo } from 'react';
import { Field, ErrorMessage } from 'formik';
import { Icon } from '@iconify/react/dist/iconify.js';
import '../../styles/UserProfile.css';

const Step2 = ({ values, setFieldValue, touched, errors }) => {
    const previewUrl = useMemo(() => {
        if (!values.profilePicture) return null;
        return URL.createObjectURL(values.profilePicture);
    }, [values.profilePicture]);

    useEffect(() => {
        return () => {
            if (previewUrl) URL.revokeObjectURL(previewUrl);
        };
    }, [previewUrl]);

    const handleProfilePictureChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        setFieldValue('profilePicture', file);
        event.target.value = '';
    };

    const handleRemoveProfilePicture = () => {
        setFieldValue('profilePicture', null);
    };

    return (
        <div style={{ width: '100%', maxWidth: '400px', marginBottom: '50px' }}>
            <p style={{ fontStyle: 'italic', textAlign: 'justify' }}>Great! Now we need you to tell us a bit more about yourself, so we get to know you a bit better</p>

            <div className="main-descriptions user-title" style={{ width: '100%', marginTop: '20px' }}>
                Profile Picture
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '10px', marginBottom: '20px' }}>
                {previewUrl ? (
                    <img
                        src={previewUrl}
                        alt="Profile preview"
                        style={{ width: '120px', height: '120px', borderRadius: '50%', objectFit: 'cover', marginBottom: '10px' }}
                    />
                ) : (
                    <div className="user-avatar">
                        <Icon icon="mdi:camera" className="user-edit-icon" />
                    </div>
                )}
                <div style={{ display: 'flex', flexDirection: 'row', gap: '15px', alignItems: 'center' }}>
                    <label className="file-upload-btn">
                        CHOOSE PHOTO
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleProfilePictureChange}
                            className="file-upload-input"
                        />
                    </label>
                    {previewUrl && (
                        <button
                            type="button"
                            onClick={handleRemoveProfilePicture}
                            className="file-delete-btn"
                        >
                            REMOVE PHOTO
                        </button>
                    )}
                </div>
                {touched.profilePicture && errors.profilePicture && (
                    <div style={{ color: '#CD3E3D', marginTop: '10px', textAlign: 'center' }}>
                        {errors.profilePicture}
                    </div>
                )}
            </div>

            <div className="main-descriptions user-title" style={{ width: '100%', marginTop: '20px' }}>
                Who are you?
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="fullName">Full Name</label>
                <Field name="fullName" placeholder="Dina Sardine" className="login-input" style={{ marginTop: '5px' }} />
                <ErrorMessage name="fullName" component="div" style={{ color: '#CD3E3D' }} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label htmlFor="firstLastName">First and Last Name (at your choice)</label>
                <Field name="firstLastName" placeholder="Dina Sardine" className="login-input" style={{ marginTop: '5px' }} />
                <ErrorMessage name="firstLastName" component="div" style={{ color: '#CD3E3D' }} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                <label htmlFor="nickname">Nickname <i>(Optional)</i></label>
                <Field name="nickname" placeholder="Dina" className="login-input" style={{ marginTop: '5px' }} />
                <ErrorMessage name="nickname" component="div" style={{ color: '#CD3E3D' }} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                <label htmlFor="birthDate">Date of Birth</label>
                <Field name="birthDate" type="date" className="login-input" style={{ marginTop: '5px' }} />
                <ErrorMessage name="birthDate" component="div" style={{ color: '#CD3E3D' }} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                <label htmlFor="nationality">Nationality</label>
                <Field name="nationality" placeholder="Portuguese" className="login-input" style={{ marginTop: '5px' }} />
                <ErrorMessage name="nationality" component="div" style={{ color: '#CD3E3D' }} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                <label htmlFor="naturality">Naturality</label>
                <Field name="naturality" placeholder="Lisbon" className="login-input" style={{ marginTop: '5px' }} />
                <ErrorMessage name="naturality" component="div" style={{ color: '#CD3E3D' }} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignContent: 'center', marginTop: '20px' }}>
                <p className="radio-description">Professional Status</p>
                <div className="select-wrapper">
                    <Field as="select" name="professionalStatus" className="dropdown" style={{ width: '200px', paddingLeft: '20px' }}>
                        <option value="Student">Student</option>
                        <option value="Student-Worker">Student-Worker</option>
                        <option value="Employee">Employee</option>
                        <option value="Unemployed">Unemployed</option>
                        <option value="Other">Other</option>
                    </Field>
                </div>
            </div>
        </div>
    );
};

export default Step2;
